/* sb-dc-addwhy.js — record WHY an add to cart gives up. 2026-09-02

   dc_events currently says an add failed and nothing else. Every one of the
   64 failures since 8/31 carries the same line:

       stage: "module", reason: "resolved false"

   which is sb-dc-cartlog.js reporting that __dcAddToCart returned a promise
   resolving to something other than true. The module gave up before it ever
   posted to /cart/add.js, and the log cannot say what it tripped over. The
   fields that would have told us (w, h, qty, finishing) are null in all 216
   events, because cartlog reads window.__dcSpec and the bundle never sets a
   global by that name — the live spec lives on window.__dcApi.spec.

   Two things happen here, neither of which can change the outcome of an add:

   1. window.__dcSpec is mirrored from __dcApi.spec on a short interval. That
      alone repairs the size/quantity fields in every cart_add_* event from
      now on, and it repairs the design fingerprint in sb-dc-override.js,
      which reads __dcSpec first for the same purpose.

   2. __dcAddToCart is wrapped one more time. When it resolves non-true, a
      cart_add_why row is written with the spec, the product handle, whether
      varfix spliced the variant list for that handle, how many variants the
      page ended up with, whether a print file had been produced, the
      acknowledge-issues state, the blocking issues on screen, and any
      console error or rejection seen during the attempt.

   Everything is wrapped in try/catch and the original return value is passed
   through untouched. The one job this file must never do is affect an order.

   Remove it once the failure is understood. */
(function () {
  'use strict';

  var SB_REST = 'https://uktrkymhgmzlufzxsavf.supabase.co/rest/v1/';
  var REST = null;
  var queue = [];
  var origFetch = window.fetch;

  /* ---------- credentials, lifted off the app's own REST call ------- */

  function headerBag(init, input) {
    var out = {};
    var h = (init && init.headers) || (input && input.headers) || null;
    if (!h) return out;
    try {
      if (typeof h.forEach === 'function' && !Array.isArray(h)) {
        h.forEach(function (v, k) { out[String(k).toLowerCase()] = v; });
      } else if (Array.isArray(h)) {
        h.forEach(function (p) { out[String(p[0]).toLowerCase()] = p[1]; });
      } else {
        Object.keys(h).forEach(function (k) { out[k.toLowerCase()] = h[k]; });
      }
    } catch (e) {}
    return out;
  }

  function post(rows) {
    if (!REST) return;
    try {
      origFetch.call(window, REST.url, {
        method: 'POST', headers: REST.headers,
        body: JSON.stringify(rows), keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function log(kind, ref, meta) {
    var row = { kind: kind, ref: ref ? String(ref).slice(0, 200) : null, meta: meta || null };
    if (REST) post([row]); else if (queue.length < 20) queue.push(row);
  }

  window.fetch = function (input, init) {
    try {
      if (!REST) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (url.indexOf(SB_REST) === 0) {
          var h = headerBag(init, input);
          if (h.apikey) {
            REST = {
              url: SB_REST + 'dc_events',
              headers: {
                'Content-Type': 'application/json',
                Prefer: 'return=minimal',
                apikey: h.apikey,
                Authorization: h.authorization || ('Bearer ' + h.apikey)
              }
            };
            if (queue.length) { var q = queue.splice(0, queue.length); post(q); }
          }
        }
      }
    } catch (e) {}
    return origFetch.apply(this, arguments);
  };

  /* ---------- 1. mirror the spec onto __dcSpec ---------------------- */

  setInterval(function () {
    try {
      var s = window.__dcApi && window.__dcApi.spec;
      if (s && typeof s === 'object') window.__dcSpec = s;
    } catch (e) {}
  }, 400);

  /* ---------- console capture, only while an add is running --------- */

  var noise = [];
  var listening = false;

  function note(kind, args) {
    if (!listening || noise.length >= 6) return;
    try {
      noise.push(kind + ': ' + Array.prototype.slice.call(args).map(function (a) {
        if (a instanceof Error) return a.message;
        if (typeof a === 'object') { try { return JSON.stringify(a).slice(0, 160); } catch (e) { return '[obj]'; } }
        return String(a);
      }).join(' ').slice(0, 200));
    } catch (e) {}
  }

  ['error', 'warn'].forEach(function (k) {
    var orig = console[k];
    if (typeof orig !== 'function') return;
    console[k] = function () { note(k, arguments); return orig.apply(console, arguments); };
  });
  window.addEventListener('unhandledrejection', function (e) {
    note('reject', [(e && e.reason && e.reason.message) || e.reason]);
  });

  /* ---------- what we know at the moment it gave up ----------------- */

  function issues() {
    var out = [];
    try {
      document.querySelectorAll('.proof-issues li').forEach(function (li) {
        var b = li.querySelector('b');
        if (b) out.push((li.className.indexOf('is-block') > -1 ? '!' : '') +
                        (b.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60));
      });
    } catch (e) {}
    return out.slice(0, 8);
  }

  function picture() {
    var m = {};
    try {
      var s = (window.__dcApi && window.__dcApi.spec) || window.__dcSpec || {};
      m.w = s.widthIn != null ? s.widthIn : null;
      m.h = s.heightIn != null ? s.heightIn : null;
      m.qty = s.quantity != null ? s.quantity : null;
      m.finishing = (s.finishing && (s.finishing.id || s.finishing)) || null;
      m.material = (s.material && (s.material.id || s.material)) || null;
    } catch (e) {}
    try {
      var p = window.__dcSelectedProduct || {};
      m.handle = p.handle || null;
      m.unit = p.unit || null;
      m.variants = (p.variants && p.variants.length) || null;
    } catch (e) {}
    try { m.varfix = window.__dcVarfix ? window.__dcVarfix.count : null; } catch (e) {}
    try { m.print = !!window.__dcLastPrintUrl; } catch (e) {}
    try { m.override = (typeof window.__dcOverrideOn === 'function') ? !!window.__dcOverrideOn() : null; } catch (e) {}
    try { m.blocked = document.querySelectorAll('.proof-issues li.is-block').length || 0; } catch (e) {}
    m.issues = issues();
    if (noise.length) m.console = noise.slice(0);
    return m;
  }

  function ref() {
    try {
      if (window.__dcDesignId) return window.__dcDesignId;
      var m = String(window.__dcLastPrintUrl || '').match(/dc-prints\/(dsn_[a-z0-9]+)/i);
      if (m) return m[1];
    } catch (e) {}
    return null;
  }

  /* ---------- 2. wrap the add ---------------------------------------
     Sits outside cartlog's wrapper, so cartlog keeps writing its own
     cart_add_* rows exactly as before and this only adds one more. */

  function wrap(orig) {
    var f = function () {
      noise = [];
      listening = true;
      var stop = function () { listening = false; };
      setTimeout(stop, 20000);

      var out;
      try {
        out = orig.apply(this, arguments);
      } catch (e) {
        try { log('cart_add_why', ref(), Object.assign(picture(), { at: 'throw', err: String((e && e.message) || e).slice(0, 200) })); } catch (e2) {}
        stop();
        throw e;
      }
      if (!out || typeof out.then !== 'function') {
        if (out === false) { try { log('cart_add_why', ref(), Object.assign(picture(), { at: 'sync-false' })); } catch (e) {} }
        stop();
        return out;
      }
      return out.then(function (ok) {
        try {
          if (ok !== true) log('cart_add_why', ref(), Object.assign(picture(), { at: 'resolved', value: String(ok) }));
        } catch (e) {}
        stop();
        return ok;
      }, function (e) {
        try { log('cart_add_why', ref(), Object.assign(picture(), { at: 'rejected', err: String((e && e.message) || e).slice(0, 200) })); } catch (e2) {}
        stop();
        throw e;
      });
    };
    f.__dcWhyWrapped = true;
    return f;
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (typeof window.__dcAddToCart === 'function' && !window.__dcAddToCart.__dcWhyWrapped) {
      window.__dcAddToCart = wrap(window.__dcAddToCart);
      clearInterval(timer);
      return;
    }
    if (++tries > 150) clearInterval(timer);
  }, 200);
})();
